import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import TicketsDetails from './ticketsDetails'
import TripDetails from './tripDetails'

import * as actions from './actions'
import { routePrefix } from '../../config'

import './styles.css'

class ETMTicketsContainer extends React.Component {

  componentWillUnmount() {
    this.props.clearAllData();
  }

  render() {
    return (
      <Switch>
        <Route exact path={routePrefix + '/etm-tickets/:tripId'} component={TicketsDetails} />
        <Route exact path={routePrefix + '/etm-tickets'} component={TripDetails} />
      </Switch>
    )
  }
}

const mapStateToProps = store => ({})

const mapDispatchToProps = dispatch => ({
  clearAllData: () => dispatch(actions.clearAllData())
})

ETMTicketsContainer.propTypes = {
  clearAllData: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(ETMTicketsContainer)
